import React, { useCallback, useMemo, useState } from 'react';
import { LFC } from '../../../Legacy';
import { TabularData, TabularImportParams, TabularImportStrategy } from './TabularImportModel';

export interface TabularImportStepSequenceProps {
    data: TabularData;
    initialParams?: TabularImportParams;
    strategy: TabularImportStrategy;
    onComplete: (params: TabularImportParams) => void;
    onCancel: () => void;
}

const initParams = (data: TabularData, initial?: TabularImportParams) =>
    Object.assign(TabularImportParams.from(data), initial ?? {});

export const TabularImportStepSequence: LFC<TabularImportStepSequenceProps> = ({ data, initialParams, strategy, onComplete, onCancel }) => {

    const [params, setParams] = useState(useMemo(() => initParams(data, initialParams), [data, initialParams]));
    const [index, setIndex] = useState(0);

    const onStep = useCallback((nextParams: TabularImportParams, advance: number) => {
        const nextIndex = index + advance;
        if (nextIndex < 0) {
            onCancel();
        }
        else if (nextIndex >= strategy.steps.length) {
            onComplete(nextParams);
        }
        else {
            setParams(nextParams);
            setIndex(nextIndex);
        }
    }, [index, strategy, onComplete, onCancel]);

    const ActiveStep = strategy.steps[index];

    return <>
        {ActiveStep && <ActiveStep data={data} params={params} onStep={onStep} />}
    </>;
};
